export default "__VITE_ASSET__Iw9eYnGe__"